import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import { LabeledText } from '../CustomTypography'
import { ViewIcon } from '../icons'
import { FoundationDescription } from './FoundationDescription'
import { FC, ReactNode } from 'react'
import { IOrganizationAddress } from '../../types'

interface PrivateFoundationDetailProps {
  privateFoundation: any
  AddToProjectButton?: ReactNode
}

export const PrivateFoundationDetail: FC<PrivateFoundationDetailProps> = ({ privateFoundation, AddToProjectButton }) => {
  const {
    organizationUrl = '',
    organizationName = '',
    organizationDescription = '',
      formattedDisbursedCharityAmount,
    organizationAddress = {} as IOrganizationAddress,
  } = privateFoundation

  const { state = '', city = '' } = organizationAddress

  return (
    <Box height="100%" py={2} px={3}>
      <Typography color="secondary" fontSize="1.5rem" fontWeight={600}>
        {organizationName}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Stack gap={2}>
          <LabeledText value={`${state}, ${city}`} label="Location" />

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <LabeledText
              label="Grant paid out"
              value={`$${formattedDisbursedCharityAmount}`}
              valueProps={{ fontSize: '1.5rem', fontWeight: 700 }}
            />

            <LabeledText
              label="Total asset value"
              value="--"
              rootContainerProps={{ alignItems: 'flex-end' }}
            />
          </Stack>

          <LabeledText label="URL" value={organizationUrl || '--'} />
        </Stack>

        <FoundationDescription description={organizationDescription} />
      </Box>

      <Stack my={3} direction='row' gap={2}>
        {
          AddToProjectButton ?? <></>
        }

        <Button
          fullWidth
          color="primary"
          variant="contained"
          disableElevation={true}
          startIcon={<ViewIcon />}
          sx={{
            padding: '0.9rem 0',
            borderRadius: '8px',
            textTransform: 'none',
          }}
          onClick={() => organizationUrl && window.open(organizationUrl, '_blank')}
        >
          View foundation
        </Button>
      </Stack>


    </Box>
  )
}
